document.addEventListener("DOMContentLoaded", function () {
   console.log("Test app");

   /* ================= COUNTRY CODES (LADA) ================= */
   const COUNTRY_CODES = [
      { code: "+1",   flag: "🇺🇸", label: "US/CA" },
      { code: "+52",  flag: "🇲🇽", label: "MX" },
      { code: "+44",  flag: "🇬🇧", label: "UK" },
      { code: "+49",  flag: "🇩🇪", label: "DE" },
      { code: "+33",  flag: "🇫🇷", label: "FR" },
      { code: "+34",  flag: "🇪🇸", label: "ES" },
      { code: "+39",  flag: "🇮🇹", label: "IT" },
      { code: "+351", flag: "🇵🇹", label: "PT" },
      { code: "+55",  flag: "🇧🇷", label: "BR" },
      { code: "+54",  flag: "🇦🇷", label: "AR" },
      { code: "+57",  flag: "🇨🇴", label: "CO" },
      { code: "+56",  flag: "🇨🇱", label: "CL" },
      { code: "+51",  flag: "🇵🇪", label: "PE" },
      { code: "+58",  flag: "🇻🇪", label: "VE" },
      { code: "+593", flag: "🇪🇨", label: "EC" },
      { code: "+61",  flag: "🇦🇺", label: "AU" },
      { code: "+64",  flag: "🇳🇿", label: "NZ" },
      { code: "+81",  flag: "🇯🇵", label: "JP" },
      { code: "+86",  flag: "🇨🇳", label: "CN" },
      { code: "+82",  flag: "🇰🇷", label: "KR" },
      { code: "+91",  flag: "🇮🇳", label: "IN" },
      { code: "+971", flag: "🇦🇪", label: "AE" },
      { code: "+27",  flag: "🇿🇦", label: "ZA" },
   ];

   function populatePhoneLada(selectEl) {
      COUNTRY_CODES.forEach(function (c) {
         const opt = document.createElement("option");
         opt.value = c.code;
         opt.textContent = c.flag + " " + c.code;
         if (c.code === "+1") opt.selected = true;
         selectEl.appendChild(opt);
      });
   }

   document.querySelectorAll(".phone-lada").forEach(populatePhoneLada);

   document.getElementById("terms-popup").addEventListener("click", (e) => {
      e.preventDefault();
      document.querySelector("body").classList.add("kill-overflow");
      document.querySelector("#terms-wholesale").classList.add("open");
   });

   document.querySelectorAll(".close--popup-terms").forEach((item) => {
      item.addEventListener("click", (e) => {
         document.querySelector("body").classList.remove("kill-overflow");
         document.querySelector("#terms-wholesale").classList.remove("open");
      });
   });

   /*  COPY FILEDS */

   document.querySelector("#copy-fields_1").addEventListener("click", (e) => {
      e.target.disabled = true;

      let mainName = document.getElementById("name-mod-1").value;
      let accountingNameMod2 = document.getElementById("phone-mod-1").value;
      let emailMod1 = document.getElementById("email-mod-1").value;
      let ladaMod1 = document.getElementById("phone-lada-mod-1").value;

      document.getElementById("accounting-phone-mod-2").value = accountingNameMod2;
      document.getElementById("accounting-phone-lada-mod-2").value = ladaMod1;

      document.getElementById("sales-phone-mod-2").value = accountingNameMod2;
      document.getElementById("sales-phone-lada-mod-2").value = ladaMod1;

      document.getElementById("accounting-name-mod-2").value = emailMod1;
      document.getElementById("main_sales_contact_email").value = emailMod1;

      document.getElementById("accounting_contact_name").value = mainName;
      document.getElementById("sales-name-mod-2").value = mainName;
   });

   document.querySelector("#copy-fields").addEventListener("click", (e) => {
      e.target.disabled = true;

      let accountingAddress = document.getElementById("address-mod-1").value;
      let accountingCity = document.getElementById("city-mod-1").value;
      let accountingState = document.getElementById("state-mod-1").value;

      let accountingZipcode = document.getElementById("zip-mode-1").value;
      let accountingPhone = document.getElementById("phone-mod-1").value;
      let accountingLada = document.getElementById("phone-lada-mod-1").value;
      let accountingEmail = document.getElementById("email-mod-1").value;

      document.getElementById("address-mod-3").value = accountingAddress;
      document.getElementById("city-mod-3").value = accountingCity;
      document.getElementById("state-mod-3").value = accountingState;

      document.getElementById("zip-mode-3").value = accountingZipcode;
      document.getElementById("company-phone-mod-2").value = accountingPhone;
      document.getElementById("company-phone-lada-mod-2").value = accountingLada;
      document.getElementById("sales-email-mod-2").value = accountingEmail;
   });

   /* ================= MESSAGE HANDLER ================= */
   const msg = (el, success) => {
      let anchor = document.getElementById("view-msg");

      if (success) {
         anchor.style.color = "#008060";
         anchor.innerHTML = `Sent successfully`;
         setTimeout(() => (anchor.innerHTML = ""), 3500);
      } else {
         el.focus();
         anchor.style.color = "red";
         anchor.innerHTML = `${el.dataset.name} field is empty`;
         setTimeout(() => (anchor.innerHTML = ""), 5000);
      }
   };

   /* ================= ONLY RUN ON WHOLESALE PAGE ================= */
   if (!document.body.classList.contains("wholesale_form")) return;

   let currStep;
   const validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

   const form = document.getElementById("form-data-wholesale");
   const submitBtn = document.getElementById("send-frm-progress");
   const submitText = submitBtn.querySelector("span");

   document.querySelectorAll(".frm--btn.next-form").forEach((btn) => {
      btn.addEventListener("click", async function (e) {
         e.preventDefault();
         console.log("click");

         currStep = this.dataset.current;
         let success = false;

         /* ================= MODULE 1 ================= */
         const name = document.getElementById("name-mod-1");
         const website = document.getElementById("website-mod-3");
         const country = document.getElementById("website-mod-3");
         const nameMod1 = document.getElementById("name-mod-1");
         const lastNameMod1 = document.getElementById("last-name-mod-1");
         const addressMod1 = document.getElementById("address-mod-1");
         const cityMod1 = document.getElementById("city-mod-1");
         const stateMod1 = document.getElementById("state-mod-1");
         const zipCodeMod1 = document.getElementById("zip-mode-1");
         const phoneMod1 = document.getElementById("phone-mod-1");
         const emailMod1 = document.getElementById("email-mod-1");

         /* ================= MODULE 2 ================= */
         const accountingName = document.getElementById(
            "accounting_contact_name",
         );
         const accountingPhoneMod2 = document.getElementById(
            "accounting-phone-mod-2",
         );
         const salesNameMod2 = document.getElementById("sales-name-mod-2");
         const salesPhoneMod2 = document.getElementById("sales-phone-mod-2");
         const mainSalesEmail = document.getElementById(
            "main_sales_contact_email",
         );

         /* ================= MODULE 3 ================= */
         const companyMod3 = document.getElementById("company-mod-3");
         const feinMod3 = document.getElementById("federal-employer-mod-3");
         const resellerNumberMod3 = document.getElementById(
            "reseller-number-mod-3",
         );
         const aboutCompanyMod3 = document.getElementById(
            "about-company-mod-3",
         );
         const businessType = document.getElementById("business_type");
         const aboutColorfastMod3 = document.getElementById(
            "about-color-fast-mod-3",
         );
         const companyGoalsMod3 = document.getElementById(
            "company-goals-mod-3",
         );
         const companyPhoneMod3 = document.getElementById(
            "company-phone-mod-2",
         );
         const termsAcept = document.getElementById("accept-mod-3");
         const termsAceptColor = document.getElementById("accept-color-mod-3");

         /* ================= VALIDATION ================= */
         if (currStep === "3") {
            if (!nameMod1.value) return msg(nameMod1);
            if (!lastNameMod1.value) return msg(lastNameMod1);
            if (!addressMod1.value) return msg(addressMod1);
            if (!cityMod1.value) return msg(cityMod1);
            if (!stateMod1.value) return msg(stateMod1);
            if (!zipCodeMod1.value) return msg(zipCodeMod1);
            if (!phoneMod1.value) return msg(phoneMod1);
            if (!emailMod1.value || !validRegex.test(emailMod1.value))
               return msg(emailMod1);
            if (!aboutCompanyMod3.value) return msg(aboutCompanyMod3);
            if (!businessType.value) return msg(businessType);
            if (!aboutColorfastMod3.value) return msg(aboutColorfastMod3);
            if (!companyGoalsMod3.value) return msg(companyGoalsMod3);
            if (!termsAcept.checked) return msg(termsAcept);
            if (!termsAceptColor.checked) return msg(termsAceptColor);

            /* ================= AUTOFILL ================= */
            const ladaMod1 = document.getElementById("phone-lada-mod-1").value;
            if (!companyMod3.value) companyMod3.value = nameMod1.value;
            if (!salesNameMod2.value) salesNameMod2.value = nameMod1.value;
            if (!companyPhoneMod3.value) {
               companyPhoneMod3.value = phoneMod1.value;
               document.getElementById("company-phone-lada-mod-2").value = ladaMod1;
            }
            if (!accountingPhoneMod2.value) {
               accountingPhoneMod2.value = phoneMod1.value;
               document.getElementById("accounting-phone-lada-mod-2").value = ladaMod1;
            }
            if (!salesPhoneMod2.value) {
               salesPhoneMod2.value = phoneMod1.value;
               document.getElementById("sales-phone-lada-mod-2").value = ladaMod1;
            }
            if (!mainSalesEmail.value) mainSalesEmail.value = emailMod1.value;
            if (!accountingName.value) accountingName.value = nameMod1.value;

            /* ================= UI: SENDING STATE ================= */
            submitText.innerText = "Sending...";
            submitBtn.disabled = true;

            /* ================= PREPARAR DATOS PARA SUPABASE ================= */
            const formData = new FormData(form);

            /* ================= ENVIAR A SUPABASE ================= */
            try {
               const res = await fetch(
                  "https://kiehgncgwpdicfemclwn.supabase.co/functions/v1/wholesale-form",
                  {
                     method: "POST",
                     headers: {
                        Authorization:
                           "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtpZWhnbmNnd3BkaWNmZW1jbHduIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk0NDAxMDQsImV4cCI6MjA4NTAxNjEwNH0.DClO8VoAV3U_PVaxcbiNWAdVvQEkm-NUgmi9WOkIWHY",
                     },
                     body: formData,
                  },
               );

               const result = await res.json();

               if (result.success) {
                  console.log("Datos enviados a Supabase ✅");
               } else {
                  console.warn("Error en Supabase:", result.error);
               }
            } catch (err) {
               console.error("Error de conexión Supabase:", err.message);
            }

            /* ================= EMAILJS SUBMIT ================= */
            const fileInput = document.getElementById("reseller-certificate");
            if (fileInput) fileInput.disabled = true;

            emailjs
               .sendForm("service_zpyns48", "template_gxushuc", form)
               .then(function () {
                  success = true;
                  document.body.classList.add("kill-overflow");
                  document.getElementById("request-send").classList.add("open");
                  msg("", success);
                  form.reset();
               })
               .catch(function (error) {
                  console.error("EmailJS error:", error);
                  alert("Error sending form. Try again.");
               })
               .finally(function () {
                  submitText.innerText = "Submit";
                  submitBtn.disabled = false;
                  if (fileInput) fileInput.disabled = false;
               });
         }
      });
   });

   /* ================= CLOSE SUCCESS POPUP ================= */
   document.querySelectorAll(".close--popup-success").forEach((btn) => {
      btn.addEventListener("click", () => {
         document.body.classList.remove("kill-overflow");
         document.getElementById("request-send").classList.remove("open");
         form.reset();
         location.reload();
      });
   });
});
